(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name exam.factory:ExamHelper
   *
   * @description
   *
   */
  angular
    .module('vcexam')
    .factory('ExamHelper', ExamHelper);

  ExamHelper.$inject = ['Exam', 'Patdocs', '$http', '$log', 'Rlog', '$uibModal', '$timeout'];

  function ExamHelper(Exam, Patdocs, $http, $log, Rlog, $uibModal, $timeout ) {
    // private


    // public
    let service = {};

    // used in scansorter and examlist view
    service.editPostExam = function (exam) {
      $log.debug('examlist editExam called with: ', exam);
      $uibModal.open({
        template: `
                <div class="modalspacer">
                  <postexameditor exam="lc.exam" dialog="lc.dialog"></postexameditor>
                </div>`,
        size: 'lg',
        controller: ['lexam', '$uibModalInstance', function (lexam, $uibModalInstance) {
          let lc = this;
          $log.debug('lexam inside modal controaller: ', lexam);
          lc.exam = lexam;
          lc.dialog = $uibModalInstance;
        }],
        controllerAs: 'lc',
        resolve: {
          lexam: () => {
            $log.debug('exam inside resolve: ', exam);
            return exam;
          }
        }
      });

    };

    // used in examtemplate list view to preview new templates on a defined sample patient
    service.editSampleExam = function (exam) {
      $log.debug('examlist editSampleExam called with: ', exam);
      $uibModal.open({
        template: `
                <div class="modalspacer">
                  <sampleexameditor exam="lc.exam" dialog="lc.dialog"></sampleexameditor>
                </div>`,
        size: 'lg',
        controller: ['lexam', '$uibModalInstance', function (lexam, $uibModalInstance) {
          let lc = this;
          $log.debug('lexam inside modal controaller: ', lexam);
          lc.exam = lexam;
          lc.dialog = $uibModalInstance;
        }],
        controllerAs: 'lc',
        resolve: {
          lexam: () => {
            $log.debug('exam inside resolve: ', exam);
            return exam;
          }
        }
      });

    };


    service.finishExam = function finishExam(exam) {
      $log.debug('exam helper factory finishexam called');
      exam.open = false;


      // build diagnosis string from parts for quick reference
      if (angular.isObject(exam.template.diagnosis)) {
        exam.diagnosis = '';
        for (let i = 0; i < exam.template.diagnosis.avalues.length; i++) {
          exam.diagnosis += exam.template.diagnosis.avalues[i].name;
          if (i !== exam.template.diagnosis.avalues.length - 1) {
            exam.diagnosis += ', ';
          }
        }
      }

      // add formated date vor easy identification and display ordering
      exam.time = moment().format('HH:mm');

      // test if biopsie entries where actually created
      if (angular.isObject(exam.template.biopsy) && exam.template.biopsy.biopsies.length > 0) {
        let biopsies = exam.template.biopsy.biopsies;
        let btest = false;
        for (let i = 0; i < biopsies.length; i++) {
          if (biopsies[i].avalues.length > 0) {
            btest = true;
          }
        }
        if (btest) {
          createReferral(exam);
        }
      }

      if (exam.$hasPendingActions) {
        $log.warn('[EXAM][HELPER] exam save had pending actions, cancelling now.');
        exam.$cancel();
        $timeout(function () {
          $log.warn('[EXAM][HELPER]  waited 1.5 seconds because of exam having had pending actions, saving now.');
          savesave(exam);
        }, 1500);
      } else {
        savesave(exam);
      }
    };


    function savesave(exam) {
      exam.$save().$then(function () {
        $log.debug('exam helper factory finishexam save successful');

      }, function () {
        $log.error('exam helper factory finishexam save failed');

        Rlog.debug('exam', 'examhelperfactory', 'exam finish (save) failed', {examid: exam._id});
      });
    }

    function createReferral(exam) {
      let newreferral = {};
      if (angular.isObject(exam.template.biopsy.pathology)) {
        newreferral.doctor = exam.template.biopsy.pathology;
      }
      else {
        newreferral.to = 'Pathologie';
      }

      if (angular.isString(exam.template.biopsy.pathdiag)) {
        newreferral.diag = exam.template.biopsy.pathdiag;
      }
      else {
        newreferral.diag = 'Auffälligkeiten';
      }

      if (angular.isString(exam.template.biopsy.pathcomment)) {
        newreferral.ref = exam.template.biopsy.pathcomment;
      }
      else {
        newreferral.comment = 'Biopsien';
      }

      let biolabels = [];
      let label;
      for (let i = 1; i <= exam.template.biopsy.biopsies.length; i++) {
        label = exam.template.type + ' PE ' + i + ': ';
        exam.template.biopsy.biopsies[i - 1].avalues.forEach(function (v) {
          label += v.name;
          label += ', ';
        });
        // strip last comma and space
        biolabels.push(label.substring(0, label.length - 2));
      }

      newreferral.biolabels = biolabels;
      newreferral.type = 'referral';
      newreferral.reftype = 'bio';
      newreferral.refdate = moment().locale('de-at').format('ll');
      newreferral.pdate = true;
      newreferral.consultid = exam.consultid;
      newreferral.patientid = exam.patientid;

      $log.debug('#### new biopsy referral: ', newreferral);

      Patdocs.$create(newreferral).$then(function success() {
          $log.debug('creation of biopsy referral succeeded');
        },
        function error(err) {
          $log.error('creation of biopsy referral failed: ', err);
          Rlog.error('exam', 'examhelperfactory', 'creation of biopsy referral failed',
            {
              examid: exam._id, patientid: exam.patientid,
              consultid: exam.consultid, biolabels: newreferral.biolabels
            });
        });
    }

    service.getAllOpen = function () {
      let query = {
        open: true,
        active: true
      };
      return Exam.$search(query);
    };


    service.getOneOpen = function () {
      let query = {
        open: true,
        active: true
      };
      return Exam.$search(query).$asPromise().then(function (openexams) {
        return openexams[0];
      });
    };

    service.getAllClosed = function () {
      let query = {
        open: false,
        active: true
      };
      return Exam.$search(query);
    };

    service.getAllClosedPerPatient = function (patid) {
      let query = {
        open: false,
        active: true,
        patientid: patid
      };
      return Exam.$search(query);
    };

    service.getAllOpenPerPatient = function (patid) {
      let query = {
        open: true,
        active: true,
        patientid: patid
      };
      return Exam.$search(query);
    };

    // TODO: use aggregate query to limit set
    service.getLastNPerPatient = function (patid, n) {
      let query = {
        open: true,
        active: true,
        patientid: patid
      };
      return Exam.$search(query);
    };

    service.getAllPerConsult = function (consultid) {
      let query = {
        active: true,
        consultid: consultid
      };
      return Exam.$search(query);
    };

    service.getAllClosedPerConsult = function (consultid) {
      let query = {
        open: false,
        active: true,
        consultid: consultid
      };
      return Exam.$search(query);
    };

    service.getAllPerOpenConsult = function (consultid) {
      let query = {
        open: true,
        active: true,
        consultid: consultid
      };
      return Exam.$search(query);
    };


    return service;
  }


  // lammerfriedhof
}());
